import React, { useEffect, useMemo, useState } from "react";
import "./AuctionBidResult.scss";
import { BlobProvider } from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import { userDetails } from "../../redux/user/userSelector";
import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { Auction, BidMapResponse, IAuctionHistory } from "../../models/Auction";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import AuctionReport from "../../reports/AuctionReport/AuctionReport";

interface AuctionBidResultProps {
  auction: Auction;
}

const AuctionBidResult: React.FC<AuctionBidResultProps> = ({ auction }) => {
  const currentUser = useSelector(userDetails);
  const [bids, setBids] = useState<BidMapResponse>({});

  useEffect(() => {
    fetchBidMap();
  }, []);

  const fetchBidMap = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.AUCTION.BID_REPORT(auction.id),
        {
          params: {
            type: "BID_RESULT",
          },
        },
      );
      if (data) {
        setBids(data.bids);
      }
    } catch (e) {
      console.error("Error:", e);
    }
  };

  const memoizedDocument = useMemo(() => {
    const today = dayjs().format("DD-MM-YY");
    return (
      <AuctionReport
        user={currentUser}
        currentDate={today}
        auction={auction}
        bids={bids}
      />
    );
  }, [auction, bids]);

  const handleOpenQuotationPdf = (url: string, filename: string) => {
    window.open(url, "_blank");
  };

  return (
    <BlobProvider document={memoizedDocument}>
      {({ blob, url, loading, error }) => {
        if (loading) return <CircularProgress size={20} />;
        if (error) {
          console.error("ERROR PDF", error);
          return (
            <button className="report-download-button" disabled>
              Error generating PDF
            </button>
          );
        }
        const filename = `VendorBidHistoryReport.pdf`;
        return (
          <div
            style={{ color: "#5151EC" }}
            className="flex-row align-items-center justify-content-center gap-8 cursor-pointer"
            onClick={() => handleOpenQuotationPdf(url || "", filename)}
          >
            <img
              height={16}
              width={16}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240904094334-download_purple.svg"
              alt="download-icon"
            />
            <p>Download Result</p>
          </div>
        );
      }}
    </BlobProvider>
  );
};

export default AuctionBidResult;
